import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

function functionsBaseUrl() {
  const raw =
    process.env.REACT_APP_FUNCTIONS_BASE_URL ||
    process.env.REACT_APP_BACKEND_URL ||
    'https://us-central1-isgerk-vaistus.cloudfunctions.net';
  return raw.replace(/\/createCheckoutSession\/?$/i, '').replace(/\/$/, '');
}

export default function SuccessPage() {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');
  const [status, setStatus] = useState(sessionId ? 'loading' : 'ok');

  useEffect(() => {
    if (!sessionId) {
      return;
    }

    let cancelled = false;

    const verify = async () => {
      try {
        const response = await fetch(`${functionsBaseUrl()}/verifyCheckoutSession`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ session_id: sessionId }),
        });

        const data = await response.json();
        if (!response.ok || !data.ok) {
          throw new Error(data.error || 'Nepavyko patvirtinti mokėjimo');
        }

        if (!cancelled) {
          setStatus('ok');
        }
      } catch {
        if (!cancelled) {
          setStatus('ok');
        }
      }
    };

    void verify();

    return () => {
      cancelled = true;
    };
  }, [sessionId]);

  if (status === 'loading') {
    return (
      <div className="page page-center">
        <div className="card card-success">
          <h1>Apmokėta</h1>
        </div>
      </div>
    );
  }

  return (
    <div className="page page-center">
      <div className="card card-success">
        <h1>Apmokėta</h1>
      </div>
    </div>
  );
}
